import React from "react";
import styles from "./NetworkingBanner.module.css";
import bannerImgLight from "../icons/banner/light/banner.png";
import bannerImgDark from "../icons/banner/dark/banner.png";
import { useTheme } from "@/hooks/useTheme";
import { useBackButton } from "@/hooks/useBackButton";

interface NetworkingBannerProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateProfile: () => void;
}

export const NetworkingBanner: React.FC<NetworkingBannerProps> = ({
  isOpen,
  onClose,
  onCreateProfile,
}) => {
  const { theme } = useTheme();

  useBackButton({ isOpen, onBack: onClose });

  if (!isOpen) return null;

  // Выбираем изображение в зависимости от темы
  const bannerImg = theme === "dark" ? bannerImgDark : bannerImgLight;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* Иллюстрация - картинка меняется в зависимости от темы */}
        <div className={styles.illustration}>
          <img
            src={bannerImg}
            alt="Networking"
            className={styles.bannerImage}
            loading="lazy"
            decoding="async"
          />
        </div>

        {/* Контент */}
        <div className={styles.content}>
          <h2 className={styles.title}>Дорога к новым связям!</h2>
          <p className={styles.description}>
            Открывай анкеты, общайся и расширяй круг полезных контактов прямо в
            приложении
          </p>
        </div>

        {/* Кнопка */}
        <button
          className={styles.createButton}
          onClick={onCreateProfile}
        >
          Создать профиль
        </button>
      </div>
    </div>
  );
};
